import React, {useState} from "react";
import {SubmitHandler, useForm} from "react-hook-form";
import {NewCategory, NewUser, TypeForm} from "../types";
import {getError} from "../utils/getError";
import {useRegister} from "../hooks/useAuth";
import "../styles/FormAuth.scss"
import {useNavigate} from "react-router";

export function Register() {
    const [error, setError] = useState<string>("");
    const {mutate: registerUser} = useRegister()
    const [customLoading, setCustomLoading] = useState(false);


    const {
        register,
        handleSubmit,
        reset,
        formState: {errors},
    } = useForm<NewUser>()

    const onSubmit: SubmitHandler<NewUser> = async (newUser: NewUser) => {
        setCustomLoading(true)
        try {
            registerUser(newUser)
        } catch (error: any) {
            setError(getError(error));
        }
        setCustomLoading(false)
    }

    return (
        <form id="form-register" onSubmit={handleSubmit(onSubmit)}>
            <h1>Inscription</h1>
            <label>Nom et Prénom</label>
            <input autoFocus {...register("full_name")} required={true}/>
            <label>Email</label>
            <input type={"email"} {...register("email")} required={true}/>
            <label>Mot de passe</label>
            <input type={"password"}{...register("password")} required={true}/>
            <div className={"errorMessage"}>{error}</div>
            <button type="submit" disabled={customLoading}>Inscription</button>
        </form>
    )
}

